import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router';

const StockReportsPage = () => {
  const history = useHistory();
  const match = useRouteMatch();
  useEffect(() => {
    if (match.isExact) {
      history.replace(`/app/reports/stock/ABCAnalysis`);
    }
  }, [match]);

  return null;
};

export default StockReportsPage;
